import React from "react";
import { Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

function Footer() {
  return (
    <footer>
      <div className="w-full flex flex-col bg-[#E6B800] text-white">
        <div className="md:w-full md:px-5">
          <div className="grid grid-rows-[auto] gap-8 font-semibold py-12 px-5 md:max-w-[68rem] md:w-full md:grid-cols-[repeat(4,_auto)] md:grid-rows-1 md:py-20 md:px-0 md:mx-auto justify-between">
            <div>
              <Logo />
              <div className="mt-6 flex flex-col gap-4 font-normal">
                <div className="transition-opacity duration-150 hover:opacity-80">
                  Laan van vollenhove 2935
                </div>
                <div className="transition-opacity duration-150 hover:opacity-80 ">
                  3706 AK Zeist
                </div>
                <div className="transition-opacity duration-150 hover:opacity-80">
                  KvK-nummer 93984707
                </div>
                <div className="transition-opacity duration-150 hover:opacity-80">
                  Btw-nummer: NL866593433B01
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-4 font-normal">
              <Link
                to="/groepenkast-vervangen"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                Groepenkast vervangen
              </Link>
              <Link
                to="/kookgroep-aansluiten"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                Kookgroep aansluiten
              </Link>
              <Link
                to="/elektra-renovatie"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                Elektra renovatie
              </Link>
              <Link
                to="/3-fase-aansluiting"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                3 fasse aansluiting
              </Link>
              <Link
                to="/elektra-aanleggen"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                Elektricien aanleggen
              </Link>
              <Link
                to="/laadpaal"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                Laadpaal
              </Link>
              <Link
                to="/zonnepanelen"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                Zonnepanelen
              </Link>
              <Link
                to="/inspectie"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                Elektra inspectie
              </Link>
            </div>
            <div className="flex flex-col gap-4 font-normal">
              <Link
                to="/klantenservice"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                Klantenservice
              </Link>
              <Link
                to="/ons-verhaal"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                Ons verhaal
              </Link>
              <Link
                to="/vacatures"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                Werken bij ons
              </Link>
              <Link
                to="/begrippen"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                Begrippenlijst
              </Link>
              <Link
                to="/regios"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                Regios
              </Link>
            </div>
          </div>
        </div>
        <div className="border-t border-solid border-white/20">
          <div className="md:w-full md:px-5">
            <div className="grid grid-rows-[repeat(2,_auto)] grid-cols-[repeat(2,_auto)] gap-8 py-8 px-5 md:max-w-[68rem] md:w-full md:mx-auto md:gap-y-0 md:grid-cols-[max-content_1fr_1fr] md:grid-rows-1 px-0">
              <div className="col-[1_/_3] flex flex-col gap-2 font-semibold md:row-[1_/_1] md:col-[2_/_2] md:flex-row md:gap-8 md:items-center">
                <Link
                  to="/privacy"
                  className="text-[14px] font-normal leading-[1.56] transition-opacity duration-150 hover:opacity-80"
                >
                  Privacy
                </Link>
                <Link
                  to="/voorwaarden"
                  className="text-[14px] font-normal leading-[1.56] transition-opacity duration-150 hover:opacity-80"
                >
                  Voorwaarden
                </Link>
                <Link
                  to="/sitemap"
                  className="text-[14px] font-normal leading-[1.56] transition-opacity duration-150 hover:opacity-80"
                >
                  sitemap
                </Link>
                <Link
                  to="/cookies"
                  className="text-[14px] font-normal leading-[1.56] text-white transition-opacity duration-150 hover:opacity-80 text-left"
                >
                  Cookies
                </Link>
              </div>
              <div className="flex flex-row col-[2_/_3] gap-5 justify-end items-center md:row-[1_/_1] md:justify-end md:col-[3_/_3]">
                <a
                  href="https://facebook.com"
                  className="text-white hover:opacity-80"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a
                  href="https://instagram.com"
                  className="text-white hover:opacity-80"
                >
                  <Instagram className="w-5 h-5" />
                </a>
                <a
                  href="https://linkedin.com"
                  className="text-white hover:opacity-80"
                >
                  <Linkedin className="w-5 h-5" />
                </a>
              </div>
              <div className="col-[1_/_1] row-[2_/_2] text-[14px] md:row-[1_/_1] md:col-[1_/_1] md:flex md:justify-start md:items-center">
                <div className="text-[14px] font-normal text-gray-400">
                  © 2025 elektricieninarnhem026.nl - onderdeel Steenbergen
                  Elektriciens B.V.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
